<template>
  <div class="ai2html-slide" >
    <object-fit-wrapper class="canvas-scrolly" :aspectRatio="aspectRatio">
      <template >
        <iframe class="map-ai2html-overlay" v-if="attributes.ai2htmlsrc" :src="getAi2htmlSrc(attributes.ai2htmlsrc)" frameborder="0" scrolling="no" ></iframe>
      </template>
    </object-fit-wrapper>
  </div>
</template>

<script>
import ObjectFitWrapper from './../ObjectFitWrapper.vue'

export default {
  props: ["attributes", "aspectRatio"],
  components: { ObjectFitWrapper },
  computed: {
  },
  methods: {
    getAi2htmlSrc(src){
      return src ? "https://www.straitstimes.com/multimedia/graphics/assets/ai2html/" + src : ""
    }
  }
};
</script>

<style lang="scss">
.ai2html-slide {
  & > * {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
  }
}
</style>
